export const keepRoutes: any[] = [
  // 对列表去详情后，需要缓存组件
  {
    formPathname: '/', // 选址需求列表页
    toPathname: ['/demand/detail'] // 选址需求详情页
  }
];
